module.exports = __webpack_public_path__ + "images/home/product/features-table-289b2bb2112d4926d0919fccd7bde02a.png";